/**
 * Employee Web — `/me/loans` section layout route.
 *
 * Phase 17 Plan 02. This is the PARENT layout for `/me/loans` (landing),
 * `/me/loans/new` (request form), and `/me/loans/$id` (detail). It must render
 * an <Outlet/> so those child routes display — the landing itself lives in the
 * index route (`_auth.me.loans.index.tsx`). Rendering the landing directly here
 * (no Outlet) made every child unreachable: navigating to `/me/loans/new`
 * showed the landing instead of the request form, so "request a loan" appeared
 * to do nothing.
 * Permission gate: `loan:read:self`.
 */
import type { JSX } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";

export const Route = createFileRoute("/_auth/me/loans")({
  staticData: { breadcrumb: { labelKey: "loans:me.loans.page.title" } },
  beforeLoad: requirePermission({
    anyOf: ["loan:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeLoansRoute,
});

function MeLoansRoute(): JSX.Element {
  return <Outlet />;
}
